"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioWithLabelContainer = exports.RadioGroup = exports.Radio = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _label = _interopRequireDefault(require("./label"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _radioModule = _interopRequireDefault(require("./radio.module.scss"));
var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));
var _labelModule = _interopRequireDefault(require("./label.module.scss"));
var _field = require("./field");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
// Radio button group
// ==================

class Radio extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      checked: false
    });
    if (props.checked !== undefined) {
      this.state.checked = props.checked;
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.checked !== undefined && prevProps.checked !== this.props.checked) {
      this.setState((_state, props) => ({
        checked: props.checked
      }));
    }
  }
  onChange(value) {
    return () => {
      if (this.props.onChange) {
        this.props.onChange(this.props.value);
      }
    };
  }
  render() {
    const id = this.props.id || (0, _field.makeIdString)();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_radioModule.default.Radio, this.props.classNames.wrapper)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: this.props.classNames.radioInputTagWrapper
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: this.props.name,
      value: this.props.value,
      disabled: this.props.disabled,
      checked: this.state.checked,
      id: id,
      className: (0, _classnames.default)(_radioModule.default.field, this.props.classNames.field, {
        [_radioModule.default.fieldInvalid]: this.props.errorMessage,
        [_radioModule.default.inputDisabled]: this.props.disabled,
        [this.props.classNames.inputDisabled]: this.props.disabled
      }),
      "aria-label": this.props.ariaLabel,
      onChange: this.onChange(this.props.value),
      onBlur: this.props.onBlur
    })), /*#__PURE__*/_react.default.createElement(_label.default, {
      className: (0, _classnames.default)(_radioModule.default.label, {
        [_radioModule.default.disabled]: this.props.disabled,
        [_radioModule.default.labelDisabled]: this.props.disabled,
        [this.props.classNames.labelDisabled]: this.props.disabled
      }, this.props.classNames.label),
      for: id
    }, this.props.label), this.props.children);
  }
}

/**
 * Radio component with a label element as the container
 * useful too maintain onChange for Radio buttons that require a custom styled conatiner
 */
exports.Radio = Radio;
class RadioWithLabelContainer extends Radio {
  render() {
    const id = this.props.id || (0, _field.makeIdString)();
    return /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: id,
      className: (0, _classnames.default)(_radioModule.default.Radio, this.props.classNames.wrapper, _radioModule.default.pointer)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: this.props.classNames.radioInputTagWrapper
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: this.props.name,
      value: this.props.value,
      disabled: this.props.disabled,
      checked: this.state.checked,
      id: id,
      className: (0, _classnames.default)(_radioModule.default.field, this.props.classNames.field, {
        [_radioModule.default.fieldInvalid]: this.props.errorMessage,
        [_radioModule.default.inputDisabled]: this.props.disabled,
        [this.props.classNames.inputDisabled]: this.props.disabled
      }),
      "aria-label": this.props.ariaLabel,
      onChange: this.onChange(this.props.value),
      onBlur: this.props.onBlur
    })), this.props.label && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_radioModule.default.label, _labelModule.default.LabelDefault, {
        [_radioModule.default.disabled]: this.props.disabled,
        [_radioModule.default.labelDisabled]: this.props.disabled,
        [this.props.classNames.labelDisabled]: this.props.disabled
      }, this.props.classNames.label)
    }, this.props.label), this.props.children);
  }
}
exports.RadioWithLabelContainer = RadioWithLabelContainer;
Radio.propTypes = _objectSpread(_objectSpread({}, _field.fieldPropTypes), {}, {
  children: _propTypes.default.node,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  classNames: _propTypes.default.shape({
    wrapper: _propTypes.default.string,
    field: _propTypes.default.string,
    labelDisabled: _propTypes.default.string,
    inputDisabled: _propTypes.default.string,
    label: _propTypes.default.string,
    radioInputTagWrapper: _propTypes.default.string
  })
});
Radio.defaultProps = {
  checked: false,
  disabled: false,
  classNames: {}
};
class RadioGroup extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      selected: ''
    });
    (0, _defineProperty2.default)(this, "onChange", value => {
      if (this.props.onChange) {
        this.props.onChange(value);
      } else {
        this.setState({
          selected: value
        });
      }
    });
    if (props.selected !== undefined) {
      this.state.selected = props.selected;
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.selected !== undefined && prevProps.selected !== this.props.selected) {
      this.setState((_state, props) => ({
        selected: props.selected
      }));
    }
  }
  renderErrorMessage() {
    return /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
      message: this.props.errorMessage,
      className: (0, _classnames.default)(_radioModule.default.radioGroupErrorMessage, this.props.classNames.errorMessage)
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_radioModule.default.RadioGroup, {
        [_radioModule.default.RadioGroupHorizontal]: this.props.isHorizontal
      })
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      className: (0, _classnames.default)(_radioModule.default.groupLabel, this.props.classNames.groupLabel, {
        [_textfieldModule.default.errorLabel]: this.props.errorMessage,
        [_radioModule.default.radioGroupLabelDisabled]: this.props.disabled,
        [this.props.classNames.disabled]: this.props.disabled
      })
    }, this.props.label), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_radioModule.default.groupWrap, this.props.classNames.radioGroup, {
        [_radioModule.default.groupWrapHorizontal]: this.props.isHorizontal
      })
    }, _react.default.Children.map(this.props.children, child => {
      if (child === null) {
        return child;
      }
      return /*#__PURE__*/_react.default.cloneElement(child, {
        name: this.props.name,
        onChange: this.onChange,
        checked: this.state.selected === child.props.value,
        onBlur: this.props.onBlur
      });
    }), this.props.errorMessage && this.renderErrorMessage()));
  }
}
exports.RadioGroup = RadioGroup;
RadioGroup.propTypes = _objectSpread(_objectSpread({}, _field.fieldPropTypes), {}, {
  children: _propTypes.default.node,
  selected: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  classNames: _propTypes.default.shape({
    radioGroup: _propTypes.default.string,
    groupLabel: _propTypes.default.string,
    errorMessage: _propTypes.default.string,
    disabled: _propTypes.default.string
  })
});
RadioGroup.defaultProps = {
  classNames: {},
  disabled: false
};